import React, { createContext, useContext, useState, useMemo } from "react";
import LampAnimation from "./LampAnimation"; // Asegúrate de importar correctamente el componente de animación

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState("light");
  const [showAnimation, setShowAnimation] = useState(false);

  const toggleTheme = () => {
    const newTheme = theme === "light" ? "dark" : "light";

    // Activar la animación
    setShowAnimation(true);

    setTimeout(() => {
      setShowAnimation(false);
      setTheme(newTheme);
    }, 2000); // Duración de la animación
  };

  // Derivar el estado booleano
  const isDarkMode = theme === "dark";

  const value = useMemo(
    () => ({
      theme,
      isDarkMode,
      toggleTheme,
    }),
    [theme, isDarkMode]
  );

  return (
    <ThemeContext.Provider value={value}>
      {children}
      {/* Renderizar la animación */}
      <LampAnimation
        theme={theme}
        isVisible={showAnimation}
        onAnimationEnd={() => setShowAnimation(false)}
      />
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
